import { api } from './client';

export interface AboutInfo {
  backend_version: string;
  node_version: string;
  started_at: string;
  build_date?: string;
  git_commit?: string;
}

export interface FeatureHistoryEntry {
  wp_number: string;
  title: string;
  phase: number | null;
  solved_at: string | null;
}

export const fetchAbout = (): Promise<AboutInfo> =>
  api.get<AboutInfo>('/about').then(r => r.data);

export const fetchFeatureHistory = (): Promise<FeatureHistoryEntry[]> =>
  api.get<FeatureHistoryEntry[]>('/about/feature-history').then(r => r.data);

export const triggerUpdate = (): Promise<{ ok: boolean; message: string }> =>
  api.post<{ ok: boolean; message: string }>('/about/update').then(r => r.data);

export const triggerRestart = (): Promise<{ ok: boolean; message: string }> =>
  api.post<{ ok: boolean; message: string }>('/about/restart').then(r => r.data);

export type CliCommandName = 'status' | 'logs';

export interface CliRunResult {
  output: string;
  exit_code: number;
}

export const runCliCommand = (command: CliCommandName): Promise<CliRunResult> =>
  api.post<CliRunResult>('/about/cli/run', { command }).then(r => r.data);
